const theme = {
  colors: {
    primary: '#d4af37', // Rich gold
    secondary: '#f5f5f5', // Off-white
    accent: '#e6c78c', // Light gold
    background: '#ffffff', // Pure white
    text: '#333333', // Dark gray for text
    lightText: '#999999', // Light gray for secondary text
    error: '#d32f2f',
    success: '#388e3c'
  },
  fonts: {
    main: "'Montserrat', 'Helvetica Neue', sans-serif",
    accent: "'Cormorant Garamond', serif" // More elegant serif font
  },
  breakpoints: {
    mobile: '576px',
    tablet: '768px',
    desktop: '1024px',
    largeDesktop: '1200px'
  },
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    xxl: '3rem'
  },
  borderRadius: {
    small: '2px', // More minimalist
    medium: '4px', // More minimalist
    large: '8px',
    round: '50%'
  },
  shadows: {
    small: '0 1px 3px rgba(0, 0, 0, 0.08)', // Softer shadows
    medium: '0 3px 6px rgba(0, 0, 0, 0.08)',
    large: '0 6px 12px rgba(0, 0, 0, 0.08)'
  },
  transitions: {
    short: '0.2s ease',
    medium: '0.3s ease',
    long: '0.5s ease'
  }
};

export default theme;
